import { useSelector } from "react-redux";
import AllowedAccess from "../../Layout/AllowedAccess";
import { Route, Routes } from "react-router-dom";
import ErrorBoundry from "../../Services/ErrorBoundry";
import MembersList from "./MembersList";
import AddMember from "./AddMember";
import UpdateMember from "./UpdateMember";
import PageNotFound from "../pageNoFound";
const MembersRoutes = () => {
	const { userData } = useSelector((state) => state.user);
	return (
		<Routes>
			<Route
				index
				element={
					<AllowedAccess
						role={userData.role_slug}
						allowedRoles={["super_admin","captain","div_admin"]}
						allowedPermissions={["users_list"]}
						userPermissions={userData.caps_list}
						renderNoAccess={() => <ErrorBoundry />}
						children={<MembersList />}
					/>
				}
			/>
			<Route path="add" element={
				<AllowedAccess
					role={userData.role_slug}
					allowedRoles={["super_admin"]}
					allowedPermissions={["add_user"]}
					userPermissions={userData.caps_list}
					renderNoAccess={() => <ErrorBoundry />}
					children={<AddMember />}
				/>
			} />
			<Route path="edit" element={
				<AllowedAccess
				role={userData.role_slug}
				allowedRoles={["super_admin"]}
				allowedPermissions={["edit_users","captain","div_admin"]}
				userPermissions={userData.caps_list}
				renderNoAccess={() => <ErrorBoundry />}
				children={<UpdateMember />}
			/>} />
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
}

export default MembersRoutes;